import TokenAnalyzerWalletStats from "./TokenAnalyzerWalletStats";

export default TokenAnalyzerWalletStats;